<template>
  <div :class="_.seckill">
    <div v-if="theme.titleType !== 'none'" :class="_.hd">
      <img
        v-if="theme.titleType === 'url'"
        :src="theme.title"
        :class="_.image"
      />
    </div>
    <div :class="[_.status, isPending && _.pending, isRunning && _.running]">
      <div :class="_.text">
        {{ isPending ? '活动未开始' : '活动进行中' }}
      </div>
      <div :class="_.time">
        <template v-if="isPending && isPendingOver24Hours">
          开始时间：{{ curData[0].extendData.startDate }}
          {{ curData[0].extendData.startTime }}
        </template>
        <template v-else>
          <div :class="_.timer">
            <div :class="_.item">{{ padZero(diff.hours) }}</div>
            <span :class="_.divider">:</span>
            <!-- <img :src="require('./images/冒号.png')" :class="_.divider" /> -->
            <div :class="_.item">{{ padZero(diff.minutes) }}</div>
            <span :class="_.divider">:</span>
            <!-- <img :src="require('./images/冒号.png')" :class="_.divider" /> -->
            <div :class="_.item">{{ padZero(diff.seconds) }}</div>
          </div>
          {{ isPending ? '后开始' : '后结束' }}
        </template>
      </div>
    </div>
    <div :class="_.bdWrapper">
      <div :class="_.bd">
        <div
          v-for="(item, index) in curData[0].childList"
          :key="item.id"
          v-track="{
            name: '秒杀-商品',
            id: `DianJiZiDingYiYeZiYuan`,
            resource: item,
            index: index,
            extra: getTrackExtra(item, index),
          }"
          :class="_.item"
          @click="$dmbcResourceClick(item)"
        >
          <img :src="item.icon" :class="_.cover" />
          <div :class="_.content">
            <div :class="_.price">
              <div :class="_.current">
                <span>￥</span>{{ item.discountAmt }}
              </div>
              <div
                v-if="
                  theme.showDashPrice === true &&
                  +item.amt &&
                  +item.amt !== +item.discountAmt
                "
                :class="_.cost"
              >
                ￥{{ item.amt }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <img
      v-track="{
        name: '秒杀-更多',
        id: `${componentId}-more`,
        resource: curData[0],
      }"
      :src="theme.image"
      :class="_.ft"
      @click="$dmbcResourceClick(curData[0])"
    />
  </div>
</template>

<script>
  import Vue from 'vue'
  import {
    anyToDate,
    differenceInHours,
    intervalToRestrictiveDuration,
    isAfter,
    isBefore,
  } from 'vtils/date'
  import { padStart } from 'vtils'

  export default Vue.extend({
    data() {
      return {
        curData: this.data,
        isPending: false,
        isRunning: false,
        isEnded: false,
        isPendingOver24Hours: false,
        diff: {},
      }
    },

    created() {
      const run = () => {
        const currentDate = new Date()
        const startDate = anyToDate(
          `${this.curData[0].extendData.activityDate} ${this.curData[0].extendData.startTime}`,
        )
        const endDate = anyToDate(
          `${this.curData[0].extendData.activityDate} ${this.curData[0].extendData.endTime}`,
        )

        const status = isAfter(startDate, currentDate)
          ? 'pending'
          : isBefore(currentDate, endDate)
          ? 'running'
          : 'ended'

        this.isPending = status === 'pending'
        this.isRunning = status === 'running'
        this.isEnded = status === 'ended'
        this.isPendingOver24Hours =
          this.isPending && differenceInHours(startDate, currentDate) > 24

        this.diff = intervalToRestrictiveDuration(
          currentDate,
          this.isPending ? startDate : endDate,
          'hour',
        )

        if (this.isEnded) {
          if (this._timer) {
            clearInterval(this._timer)
            this._timer = null
          }
          this.$dmbcApi
            .getComponentData({
              id: this.componentId,
              pageIndex: 1,
              pageSize: 100,
            })
            .then(res => {
              if (!res.list.length) {
                this.$emit('hide')
              } else {
                this.curData = res.list
                run()
                if (this.isEnded) {
                  this.$emit('hide')
                } else {
                  this._timer = setInterval(run, 1000)
                }
              }
            })
        }
      }
      run()
      if (this.isEnded) {
        this.$emit('hide')
      } else {
        this._timer = setInterval(run, 1000)
      }
    },

    beforeDestroy() {
      if (this._timer) {
        clearInterval(this._timer)
        this._timer = null
      }
    },

    methods: {
      padZero(v) {
        return padStart(v, 2, '0')
      },
    },
  })
</script>

<style lang="scss" module="_">
  .seckill {
    border-radius: var(--border-radius);
    font-size: 0;

    .hd {
      .image {
        width: 100%;
        height: auto;
        border-top-left-radius: var(--border-radius);
        border-top-right-radius: var(--border-radius);
      }
    }

    .status {
      margin-top: 6px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .text {
        margin-left: -1px;
        width: 82px;
        height: 25px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        color: #ffffff;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-position: center;
      }

      .time {
        padding-right: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        color: #555555;
        line-height: 17px;

        .timer {
          margin-right: 8px;
          display: flex;
          align-items: center;
          justify-content: center;

          .item {
            width: 19px;
            height: 19px;
            background: #f5f5f5;
            border-radius: 3px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 12px;
            font-weight: bold;
            color: #818181;
          }

          .divider {
            margin: 0 4px;
            font-weight: 700;
          }
        }
      }

      &.pending {
        .text {
          background-image: url('./images/未开始.png');
        }
      }

      &.running {
        .text {
          background-image: url('./images/进行中.png');
        }
      }
    }

    .bdWrapper {
      padding: var(--padding-top) var(--padding-right) var(--padding-bottom)
        var(--padding-left);
    }

    .bd {
      display: block;
      white-space: nowrap;
      /** 必须同时设置 y 上的，否则 iOS 13 会有拖拽效果 */
      /** 不能用简写形式（overflow: auto hidden），iPhone6s有问题 */
      overflow-x: auto;
      overflow-y: hidden;
      -webkit-overflow-scrolling: touch;

      &::-webkit-scrollbar {
        display: none;
      }

      > * {
        display: inline-block;
        white-space: normal;
      }

      .item {
        width: 114px;
        background: #ffffff;
        border-radius: 8px;
        overflow: hidden;

        .cover {
          width: 114px;
          height: 114px;
          border-radius: 8px 8px 0px 0px;
          object-fit: cover;
        }

        .content {
          height: 30px;
          display: flex;
          align-items: center;
          padding: 0 6px;

          .price {
            display: flex;
            align-items: baseline;

            .current {
              font-size: 16px;
              font-weight: bold;
              color: #ff111c;
              line-height: 16px;

              span {
                font-size: 11px;
              }
            }

            .cost {
              margin-left: 2px;
              font-size: 12px;
              color: #bebebe;
              line-height: 12px;
              text-decoration: line-through;
            }
          }
        }

        + .item {
          margin-left: 8px;
        }
      }
    }

    .ft {
      width: 100%;
      border-bottom-left-radius: var(--border-radius);
      border-bottom-right-radius: var(--border-radius);
    }
  }
</style>
